(function() {
  var AddMake, AddModel;

  AddMake = App.loadClass("grower::handlers/machinery/DialogAddMake_Handler");

  AddModel = App.loadClass("grower::handlers/machinery/DialogAddMod_Handler");

  exports.Tillage = function(parent, data) {
    var make, model, ref, ref1, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, self, subtype;
    if (data == null) {
      data = {};
    }
    self = this;
    this.addMake = function() {
      var dlg;
      dlg = parent.getHandler().createSubHandler(AddMake, 'addMachDialog');
      if (dlg) {
        dlg.subtypeId = self.selected_subtype().id;
        dlg.saveUrl = 'backend/grower/machinery/add-machinery-make';
        dlg.isforcontroll = false;
        dlg.successAction = function(data) {
          var newm;
          data.data.models = [];
          newm = data.data;
          self.machinery_makes.push(newm);
          self.machinery_makes.sort(self._comp);
          self.selected_make(newm);
          self.addModel();
          return parent.getHandler().validator.revalidateInput("[name='selected_make']");
        };
        return dlg.init();
      }
    };
    this.addModel = function() {
      var dlg;
      dlg = parent.getHandler().createSubHandler(AddModel, 'addMachDialog');
      if (dlg) {
        dlg.saveUrl = 'backend/grower/machinery/add-machinery-model';
        dlg.isforcontroll = false;
        dlg.makeId = self.selected_make().id;
        dlg.successAction = function(data) {
          var newm;
          newm = data.data;
          self.selected_make().models.push(newm);
          self.machinery_models.sort(self._comp);
          self.selected_model(newm);
          return parent.getHandler().validator.revalidateInput("[name='selected_model']");
        };
        return dlg.init();
      }
    };
    this.comp = function(a, b) {
      return strnatcasecmp(a.name, b.name);
    };
    if (((ref = data.machinery) != null ? ref.model : void 0) != null) {
      subtype = TAFFY(data.subtypes)({
        id: parseInt((ref1 = data.machinery) != null ? ref1.model.make.subtype.id : void 0)
      }).first();
      if (subtype != null) {
        make = TAFFY(subtype.makes)({
          id: parseInt((ref2 = data.machinery) != null ? ref2.model.make.id : void 0)
        }).first();
      }
      if (make != null) {
        model = TAFFY(make.models)({
          id: parseInt((ref3 = data.machinery) != null ? ref3.model.id : void 0)
        }).first();
      }
    }
    this.selected_subtype = ko.observable(subtype != null ? subtype : null);
    this.selected_make = ko.observable(make != null ? make : null);
    this.selected_model = ko.observable(model != null ? model : null);
    this.machinery_subtypes = (ref4 = data.subtypes) != null ? ref4 : [];
    this.machinery_makes = ko.observableArray((ref5 = (ref6 = this.selected_subtype()) != null ? ref6.makes : void 0) != null ? ref5 : []);
    this.machinery_models = ko.observableArray((ref7 = (ref8 = this.selected_make()) != null ? ref8.models : void 0) != null ? ref7 : []);
    this.selected_subtype.subscribe(function(newval) {
      if ((newval != null) && (newval.makes != null)) {
        return self.machinery_makes(newval.makes);
      } else {
        return self.machinery_makes([]);
      }
    });
    this.selected_make.subscribe(function(newval) {
      if ((newval != null) && (newval.models != null)) {
        return self.machinery_models(newval.models);
      } else {
        return self.machinery_models([]);
      }
    });
    this.id = (ref9 = (ref10 = data.machinery) != null ? ref10.id : void 0) != null ? ref9 : null;
    this.nickname = ko.observable((ref11 = (ref12 = data.machinery) != null ? ref12.name : void 0) != null ? ref11 : null);
    this.type = ko.observable((ref13 = (ref14 = data.machinery) != null ? ref14.model.make.subtype.name : void 0) != null ? ref13 : null);
    this.width = ko.observable((ref15 = (ref16 = data.machinery) != null ? ref16.width : void 0) != null ? ref15 : null);
    this.canChangeMake = ko.computed(function() {
      if (self.selected_subtype() && parent.editing()) {
        return true;
      } else {
        return false;
      }
    });
    this.canChangeModel = ko.computed(function() {
      if (self.selected_make() && parent.editing()) {
        return true;
      } else {
        return false;
      }
    });
    return this;
  };

}).call(this);
